export const READ_AGREEMENT_MESSAGE =
  "Please read the full agreement by scrolling down to the bottom of the document.";
export const SIGN_AGREEMENT_MESSAGE =
  'Please sign by typing your name as shown on this page (see "Accepted Signature")';
